import { render, staticRenderFns } from "./PieEchart.vue?vue&type=template&id=e59a2742&scoped=true&"
import script from "./PieEchart.vue?vue&type=script&lang=js&"
export * from "./PieEchart.vue?vue&type=script&lang=js&"
import style0 from "./PieEchart.vue?vue&type=style&index=0&id=e59a2742&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e59a2742",
  null
  
)

export default component.exports